import HeaderModal from "../../Genericos/headerModal/headerModal";
import "./MatriculaModal.css";
import InputV1 from "../../Genericos/InputV1/InputV1";
import { useContext, useState } from "react";
import {
  limpiarDatosMedico,
  limpiarMatriculaMedico,
  wsEnviarDatosMedicoSolicitante,
} from "../../../context/Actions/turnos/turnosPaciente";
import { PortalContext } from "../../../context/Provider";
import { hideModal } from "../../../context/Actions/modal/modal";

const SolicitarDatosModal = ({
  titulo,
  dissmiss,
  solicitarDatos,
  matricula,
}) => {
  const { turnosPacienteDispatch, modalDispatch } = useContext(PortalContext);

  const [btnDisabled, setBtnDisabled] = useState(true);
  const [datosForm, setDatosForm] = useState({
    telefono: "",
    email: "",
  });

  let idMedico = matricula;

  const onChangeTelefono = (e) => {
    if (e.target.value.length > 0) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
    setDatosForm({
      ...datosForm,
      telefono: e.target.value,
    });
  };

  const onNombreEmail = (e) => {
    if (e.target.value.length > 0) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
    setDatosForm({
      ...datosForm,
      email: e.target.value,
    });
  };

  const enviarDatosMedico = () => {
    hideModal()(modalDispatch);
    limpiarDatosMedico()(turnosPacienteDispatch);
    limpiarMatriculaMedico()(turnosPacienteDispatch);
    wsEnviarDatosMedicoSolicitante(
      idMedico,
      datosForm,
      solicitarDatos,
    )(turnosPacienteDispatch);
  };

  return (
    <>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} />
      <div className="ptur-matriculaModal-container">
        <div className="ptur-matriculaModal-body">
          <p className="ptur-matriculaModal-texto rb18l">
            Le pedimos que ingrese el
            <span className="rb18b"> teléfono o email del profesional</span> que
            le solicitó el estudio si cuenta con uno o ambos datos
          </p>
          <div className="ptur-matriculaModal-dobleInput">
            <InputV1
              inputType="number"
              name="txtTelefono"
              headerStr="Número de Teléfono"
              onChange={onChangeTelefono}
              className="inputNonScroll rb16m"
              isRequired={true}
            />
            <InputV1
              inputType="text"
              name="txtEmail"
              headerStr="Direccion de mail"
              onChange={onNombreEmail}
              className="rb16m"
              isRequired={true}
            />
          </div>
          <div className="ptur-matriculaModal-botonesContSolicitar">
            <div>
              <button
                className={
                  btnDisabled
                    ? "ptur-matriculaModal-buscarBtnSolicitar bgc-grey65 c-white rb16m"
                    : "ptur-matriculaModal-buscarBtnSolicitar bgc-latex30 c-white rb16m"
                }
                onClick={enviarDatosMedico}
                disabled={btnDisabled}
              >
                Enviar
              </button>
            </div>
            <div>
              <button
                className="ptur-matriculaModal-buscarBtnSolicitar bgc-danger c-white rb16m"
                onClick={dissmiss}
              >
                No lo tengo
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SolicitarDatosModal;
